import Module from "../Module";
import { initInScope } from "../elements/parsley-bootstrap-validation";


export default class Parsley extends Module {
    start($scope) {
        initInScope($scope)
    }
}
